const chainMapping: IChain = {
  'ETH': 1,
  'BSC': 56,
  'BSC_TESTNET': 97,
  'METER': 82,
  'POLYGON': 137,
  'HECO': 128,
  'AVAX': 43114,
  'FTM': 250, // alternative mapping
  'FANTOM': 250,
  'OPTIMISM': 10,
  'ARBITRUM': 42161,
  'GNOSIS': 100,
  'KLAYTN': 8217,
  'AURORA': 1313161554,
  'ELROND': 999999,
  'BTTC': 199,
  'TRON': 999998,
  'OKX': 66,
}

type IChain = {[type: string] : number}

const chainIds = Object.keys(chainMapping).map((key) => chainMapping[key])

export { chainMapping, chainIds };
